// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.5.3_webpack@5.99.9/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.5.3_webpack@5.99.9/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  background-color: var(--color-gray-01);
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  padding: 8px;
}
:host .affected-active-view {
    color: var(--primary-color);
    font-weight: var(--bold-font-weight);
  }
:host .title {
    align-items: center;
    display: flex;
    gap: var(--space-05);
  }
:host .contents {
    display: flex;
    flex-direction: column;
    gap: var(--space-025);
  }
:host .layer {
    background-color: var(--color-white-09);
    display: flex;
    flex-direction: column;
    gap: var(--space-05);
    padding: 8px;
  }`, "",{"version":3,"sources":["webpack://./src/cadenza/workbook/workbook-panel/analysis-context/affected-view-tile/affected-view-tile.module.css"],"names":[],"mappings":"AAAA;EACE,sCAAsC;EACtC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AA0Bd;AAxBE;IACE,2BAA2B;IAC3B,oCAAoC;EACtC;AAEA;IACE,mBAAmB;IACnB,aAAa;IACb,oBAAoB;EACtB;AAEA;IACE,aAAa;IACb,sBAAsB;IACtB,qBAAqB;EACvB;AAEA;IACE,uCAAuC;IACvC,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,YAAY;EACd","sourcesContent":[":host {\n  background-color: var(--color-gray-01);\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-1);\n  padding: 8px;\n\n  .affected-active-view {\n    color: var(--primary-color);\n    font-weight: var(--bold-font-weight);\n  }\n\n  .title {\n    align-items: center;\n    display: flex;\n    gap: var(--space-05);\n  }\n\n  .contents {\n    display: flex;\n    flex-direction: column;\n    gap: var(--space-025);\n  }\n\n  .layer {\n    background-color: var(--color-white-09);\n    display: flex;\n    flex-direction: column;\n    gap: var(--space-05);\n    padding: 8px;\n  }\n}"],"sourceRoot":""}]);
// Exports
var ___CSS_LOADER_STYLE_SHEET___ = new CSSStyleSheet();
___CSS_LOADER_STYLE_SHEET___.replaceSync(___CSS_LOADER_EXPORT___.toString());
export default ___CSS_LOADER_STYLE_SHEET___;
